import firebase from "firebase";
import {deserialize, serialize} from "serializr";
import { HeroKind } from "@/modules/redactor/models/hero/HeroKind";
import { HeroKindStoreUtils } from "./HeroKindStoreUtils";


export default {
    namespaced: true,
    state: {
        mHeroKinds: [],
    },
    getters: {
        getHeroKinds: state => {
            return state.mHeroKinds;
        },
    },
    mutations: {
        setHeroKinds(state, values) {
            state.mHeroKinds = values;
        },
    },
    actions: {
        init({/*commit*/}) {
            console.info("hero-kind-store initialized.");
            return HeroKindStoreUtils.fetchHeroKinds();
        },
        fetchHeroKinds({commit}) {
            console.log("fetchHeroKinds");
            let db = firebase.database();
            return Promise.all([
                db.ref("/hero-kind")
                    .once("value")
                    .then((snapshot) => {
                        let values = []
                        console.assert(snapshot != null, "snapshot is null");
                        if (snapshot.val() != null){
                            //console.log(snapshot.val())
                            Object.keys(snapshot.val()).forEach(function(key) {
                                const raw = snapshot.val()[key];
                                // console.log("fetchHeroKinds Raw:");
                                // console.log(raw);
                                let o = deserialize(HeroKind, raw)
                                o.key = key
                                values.push(o)
                            });
                        }
                        commit("setHeroKinds", values);
                        return Promise.resolve()
                    }, (reason) => {
                        console.error("fetchHeroKinds failed: " + reason);
                    }),
            ]);
        },
        createHeroKind({/*commit*/}, data) {
            console.log("createHeroKind");
            console.log(data);
            let d = serialize(HeroKind, data);
            let db = firebase.database();

            return db.ref("/hero-kind/" + d.key).set(d).then(() => {
                return HeroKindStoreUtils.fetchHeroKinds();
            }, (reason) => {
                console.error("Save failed: " + reason);
            });
        },
        deleteHeroKind({/*commit*/}, key) {
            let db = firebase.database();
            return Promise.all([
                db.ref("/hero-kind").child(key)
                    .remove()
                    .then(() => {
                        return HeroKindStoreUtils.fetchHeroKinds();
                    }),
            ]);
        },
    }
}

